import axios from 'axios';
import {api as url } from 'config';

const instance =  (options = {}) => {
	const axiosInstance = axios.create({
		...options,
		baseURL: `${options.baseURL || url}`,
		headers: {
			'Accept': 'application/json, text/plain, */*',
			'Content-Type': 'application/json',
		},
	});

	return axiosInstance;
};

const api = instance();

export default {
	getUserRankList(data, apiData) {
		return api.post(`/point/${apiData}`, data);
	},
	getNotificationsList(data) {
		return api.post('/point/notifications-get', data);
	}
};


// WEBPACK FOOTER //
// /var/www/build-health-2/src/utils/api.js